export const offensiveQueryKeys = {
  all: ['offensive'] as const,
  lists: () => [...offensiveQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...offensiveQueryKeys.lists(), filters] as const,
  details: () => [...offensiveQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...offensiveQueryKeys.details(), id] as const,
};
